import { renderScore } from "../RenderMethods";
import { scoreHelper } from "../../../../../helpers/scoreHelper/scoreHelper";
export const renderLiveScore = (event) => {
    const score = scoreHelper(event);
    return renderScore(score.homeScore, score.awayScore, event.sportId, event.scoreboard);
};
//# sourceMappingURL=renderLiveScore.js.map